import { createContext, useContext, useEffect, useLayoutEffect, useRef, useState } from "react";
import { useLocation } from "react-router";

import step3Style from "./step3.module.css";

import Text from "../custom/text";
import Agree from "./step3/agree/agree";
import Select from "consumer/custom/select";
import Radio from "consumer/custom/radio";

import Address from "./step3/address";
import Verify from "./step3/verify";
import Enroll from "./step3/enroll";
import Apply from "./step3/apply";
import Nav from "./nav";
import Fleid from "./step3/field";

import { get_schedule_info } from "consumer/@@@/get_schedule_info";
import { get_grade_list } from "consumer/@@@/get_grade_list";
import { get_field_list } from "consumer/@@@/get_field_list";
import { convert_grade_list } from "consumer/@@@/convert_grade_list";
import { SocketContext } from "context/SocketContext";

export default function Step3() {
	const location = useLocation();

	const branch_id = location.state.branch_id;
	const branch_name = location.state.branch_name;
	const event_id = location.state.event_id;
	const schedule_id = location.state.schedule_id;

	const isMounted = useRef(0);

	const [gradeList, Set_gradeList] = useState([]);
	const [gradeOption, Set_gradeOption] = useState([]);
	const [fieldList, Set_fieldList] = useState([]);

	const [sendCheck, Set_sendCheck] = useState(0);
	const [verifyCheck, Set_verifyCheck] = useState(0);
	const [enrollCheck, Set_enrollCheck] = useState(0);

	const [payment, Set_payment] = useState(0);
    const [onlyEnrolled, Set_onlyEnrolled] = useState(false)

	const { socket } = useContext(SocketContext);

	useEffect(() => {
		if (!socket || !schedule_id) return;

		socket.emit("schedule:join", {
			branchId: branch_id,
			scheduleId: schedule_id,
		});

		return () => {
			socket.emit("schedule:leave", {
				branchId: branch_id,
				scheduleId: schedule_id,
			});
		};
	}, [socket, schedule_id]);

	useLayoutEffect(() => {
		if (isMounted.current === 0) {
			// 학년 코드 가져오기
			get_grade_list({
				Set_gradeList: Set_gradeList,
				isMounted: isMounted,
			});
		}
	}, []);

	useLayoutEffect(() => {
		if (isMounted.current === 1) {
			// 일정 설정(학년, 금액)
			schedule_setup();

			// 필드 가져오기
			get_field_list({
				event_id: event_id,
				Set_fieldList: Set_fieldList,
			});
		}
	}, [gradeList]);

	async function schedule_setup() {
		const schedule_info = await get_schedule_info({
			branch_id: branch_id,
			event_id: event_id,
			schedule_id: schedule_id,
		});

		const grade = JSON.parse(schedule_info["targetGrades"]);
		const new_grade = await convert_grade_list({
			grade: grade,
			gradeList: gradeList,
		});

		Set_gradeOption(new_grade);

		Set_payment(schedule_info["payment"]);

        Set_onlyEnrolled(schedule_info["Event"]["onlyEnrolled"])
	}

	return (
		<div id="step3" className={step3Style['step3']}>
			<Nav step={3}></Nav>

			<div
				style={{
					display: "flex",
					flexDirection: "column",
					padding: "10px",
					boxSizing: "border-box",
				}}
			>
				<div style={{ display: "none" }}>
					<input
						type="text"
						name="branch_id"
						category="field"
						readOnly={true}
						required={true}
						value={branch_id}
					></input>
					<input
                        type="text"
                        name="event_id"
                        category="field"
                        readOnly={true}
                        required={true}
                        value={event_id}
                    ></input>
					<input
						type="text"
						name="schedule_id"
						category="field"
						readOnly={true}
						required={true}
						value={schedule_id}
					></input>
					<input
						type="text"
						name="enroll"
						category="field"
						readOnly={true}
						required={false}
						value={enrollCheck}
					></input>
				</div>

				<Text
                    label="학원명"
                    name="branch_name"
                    disabled={true}
                    required={true}
                    value={branch_name}
                ></Text>

				<Text
					label="학생 이름"
					name="student_name"
					max={10}
					error="학생 이름을 입력해 주세요."
					disabled={enrollCheck}
					required={true}
					event={{
						onInput: function (e) {
							const value = e.currentTarget.value;
							e.currentTarget.value = value.replace(" ", "");
						},
					}}
				></Text>

				<Text
					label="보호자 연락처"
					name="parent_phone"
					max={11}
					placeholder="－없이 입력해 주세요."
					error="보호자 연락처를 입력해 주세요."
					required={true}
					event={{
						onInput: function (e) {
							const value = e.currentTarget.value;
							e.currentTarget.value = value.replace(/[^0-9]/g, "");
						},
					}}
					disabled={sendCheck}
				></Text>

				<Verify
					verifySet={0}
					sendCheck={sendCheck}
					Set_sendCheck={Set_sendCheck}
					verifyCheck={verifyCheck}
					Set_verifyCheck={Set_verifyCheck}
				></Verify>

				<Enroll
					gradeOption={gradeOption}
					verifyCheck={verifyCheck}
					enrollCheck={enrollCheck}
					Set_enrollCheck={Set_enrollCheck}
                    onlyEnrolled={onlyEnrolled}
				></Enroll>

				<Radio
					label="학생 성별"
					name="student_sex"
					list={[
						{
							name: "남",
							value: 1,
						},
						{
							name: "여",
							value: 0,
						},
					]}
					required={true}
					error="학생 성별을 선택해 주세요."
				></Radio>

				<Select
					label="학생 학년"
					name="student_grade"
					option={[
						{
							name: "선택",
							value: "",
						},
						...gradeOption,
					]}
					required={true}
					error="학생 학년을 선택해 주세요."
				></Select>

				<Address></Address>

				<Fleid fieldList={fieldList}></Fleid>

				<Text
                    label="결제 금액"
                    name="payment"
                    disabled={true}
                    value={payment === 0 ? "무료" : Number(payment).toLocaleString()}
                ></Text>

				<Agree
                    set="person"
                    name="person"
                    required={true}
                    error="개인정보 수집 및 이용에 동의해 주세요."
                ></Agree>

				<Agree
                    set="transfer"
                    name="transfer"
                    required={true}
                    error="개인정보 제3자 제공에 동의해 주세요."
                ></Agree>

				<Agree set="promotion" name="promotion" required={false}></Agree>

				<Apply verifyCheck={verifyCheck} enrollCheck={enrollCheck}></Apply>
			</div>
		</div>
	);
}
